export default __webpack_public_path__ + "static/media/dinner6.72a66991.png";